export default __webpack_public_path__ + "static/media/tech-multiple-segments-2.e7d95848.png";